export default {"src":"/_next/static/media/desktop-hamburger.3e3267b3.svg","height":48,"width":56,"blurWidth":0,"blurHeight":0};